import React, { useState, useEffect } from 'react'
import "./Menu1.css";
import about from "../src/assets/about_1.jpg";
import Footer from './Footer';

export default function AboutMenu1() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false); // Close sidebar when switching to desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div>
      {/* Mobile Menu Toggle Button */}
      {isMobile && (
        <div className="mobile-menu-toggle" onClick={toggleSidebar}>
          <div className={`hamburger ${sidebarOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
      )}

      <div className={`small-container ${isMobile ? 'mobile' : ''}`}>
        {/* Sidebar */}
        <div className={`small-sidebar ${isMobile ? (sidebarOpen ? 'mobile-open' : 'mobile-closed') : ''}`}>
          {/* Top wave */}
          <div className="sidebar-wave-top"></div>
          <ul>
            <li>
              <a href="presidents_message" onClick={isMobile ? closeSidebar : undefined}>President's Message</a>
            </li>
            <li><a href="documents" onClick={isMobile ? closeSidebar : undefined}>Annual Report</a></li>
            <li><a href="interest" onClick={isMobile ? closeSidebar : undefined}>Interest Rate</a></li>
            <li><a href="loans" onClick={isMobile ? closeSidebar : undefined}>Loans</a></li>
            <li><a href="awards" onClick={isMobile ? closeSidebar : undefined}>Awards</a></li>
          </ul>
          {/* Bottom wave */}
          <div className="sidebar-wave"></div>
        </div>

        {/* Content Section */}
        <div className="small-content">
          <div className="image-wrapper">
            <img src={about} alt="About Us" className="small-content-image" />
          </div>
        </div>
      </div>

      <div className="history-card">
        <h3 className="history-title">History of Sahakari</h3>
        <p className="history-text">
          Established on September 2, 2001 at Puttur in Dakshina Kannada district, the home town of the banking sector, the co-operative was registered as the 9th credit Souharda co-operative in the state and the first in Dakshina Kannada district under the Karnataka Souharda Sahakari Sangha Act, 1997. The cooperative started with the slogan "Economic Empowerment through Co-operation" with the objective of providing financial security to the deposits of the members and financial support to the needs of the members in an adverse environment where the people have lost confidence due to the sharp fall in the prices of arecanut and rubber, the main crops that determine the economy of Dakshina Kannada district, and the collapse of some financial institutions in the district.
        </p>
      </div>

      <div className="history-card">
        <h3 className="history-title">Vision</h3>
        <p className="history-texts">
          " To be a premier Co-operative Society, to provide Financial solutions through Co-operative principles for enriching economic and social development."<br></br>
        </p>
        <p>
          " To emerge as a model cooperative by adopting the best standards of customer service quality along with professionalism in the field of co-operation."
        </p>
        <h3 className="history-title">Mission</h3>
        <p className="history-texts">
          " Strives for excellence in serving our members and customers by way of good professionalism, technology and good work culture."
        </p>
      </div>

      <div className="history-card">
        <h3 className="history-title">Core values</h3>
        <p className="history-texts">
          Good Principles, highest ethics and norms in conducting business.
        </p>
      </div>

      <div className="history-card">
        <h3 className="history-title">Old root new shoots, value addition in customer service with technology:</h3>
        <p className="history-texts" style={{textAlign:"justify"}}>
          While the cooperative, in line with the changes in the modern banking sector, extends customer-friendly, more easy and convenient facilities such as core banking system, safe deposit locker facility, insurance facility, etc., and in order to maintain the quality of service, continuous customer contact with the members, organizing customer days at the branch level and also providing service to the doorsteps of the members in case of need. Necessary changes are being made by taking suggestions of the members to ensure the quality of service along with training of staff from time to time with greater emphasis on customer satisfaction. In general, with members as a rich co-operative Trusted relationship is our desire.
        </p>
      </div>

      <div className="history-card">
        <h2 style={{ color: "#700d69", textAlign: isMobile ? "center" : "left", marginBottom: "20px" }}>
          Speciality of the co-operative
        </h2>
        
        <ul style={{ marginLeft: isMobile ? "10px" : "20px", textAlign:"justify"}}>
          <li style={{ color:"#000000" }}>
            An institution with state level jurisdiction.
          </li>
          <li style={{ color:"#000000" }}>Continuous growth in working capital – and owned funds.</li>
          <li style={{ color:"#000000" }}>The co-operative consistently earning profits and giving attractive dividend to Members.</li>
          <li style={{ color:"#000000" }}>Attractive Rate of interest on deposit.
            higher interest rate for senior citizens, widows, registered organizations*, specially-abled and soldiers.
          </li>
          <li style={{ color:"#000000" }}>Fully computerized cooperative with SAAS based banking solutions.</li>
          <li style={{ color:"#000000" }}>Continuous training to the staff and smiling service by trained staff.</li>
          <li style={{ color:"#000000" }}>Loans for various purposes including home loan, auto loan at competitive interest rate, Speedy loan sanction.</li>
          <li style={{ color:"#000000" }}>Loans and advances are sanctioned on the basis of repayment capacity and security offering by the members.</li>
          <li style={{ color:"#000000" }}>Active Directors.</li>
          <li style={{ color:"#000000" }}>"A" class classification in auditing.</li>
          <li style={{ color:"#000000" }}>All branches are equipped with CC cameras, alarms, strong room.</li>
          <li style={{ color:"#000000" }}>Annual Customer Contact Meetings at branch level.</li>
          <li style={{ color:"#000000" }}>Social activities by the subsidiary organization Shri Saraswathi Charitable Trust (R.).</li>
        </ul>
      </div>

      <Footer/>
    </div>
  )
}